import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import ErrorSubmitImg from '../Utils/Img/errorSubmit.svg';
import {buildUrlAndOpenSameWindow} from 'app/utilities/StringHelpers/StringHelpers';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
const CareersSubmitReject = ({context, buttonData}) => {
  function backHomePage() {
    buildUrlAndOpenSameWindow(buttonData.buttonFailedUrl);
  }

  return (
    <div className={'careers__reject'}>
      <div className='careers__reject__title'>
        <Image src={ErrorSubmitImg} alt='error' />
      </div>
      <div className='careers__reject__message'>
        <p>מצטערים, כרגע לא ניתן לבצע את הפעולה שביקשת</p>
      </div>

      <div className='careers__reject__button'>
        <BtnWhiteBlackBorderBigSize text={buttonData.buttonFailedText} onclick={() => backHomePage()} />
      </div>
    </div>
  );
};

export default CareersSubmitReject;
